<p-floatlabel variant="in" class="input-field">
  <p-select
    inputId="input_field"
    [options]="options"
    [formControl]="control"
    [checkmark]="true"
    optionLabel="displayValue"
    optionValue="id"
    [showClear]="true"
    [fluid]="true"
    [class.ng-invalid]="control.invalid && control.touched"
    [class.ng-dirty]="control.touched"
    (onChange)="changed.emit($event.value)"
  />
  <label for="input_field">{{ label }}</label>
</p-floatlabel>
@if (control.invalid && control.touched) {
  <small class="input-field-error">{{ errorMessage ?? 'This field is required' }}</small>
}
